// РУКА 2. Рубли на витрине: «4 700 ₽»; если есть копейки — всегда две цифры: «3 443,10 ₽».
const rub = new Intl.NumberFormat("ru-RU");
const kop = new Intl.NumberFormat("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function formatRub(n: number): string {
  return `${Number.isInteger(n) ? rub.format(n) : kop.format(n)} ₽`;
}
